import { render, staticRenderFns } from "./TicketBlockDelete.vue?vue&type=template&id=070531e9"
import script from "./TicketBlockDelete.vue?vue&type=script&lang=js"
export * from "./TicketBlockDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports